export const ProductCostLabelTextHelper = {
    getLabelText: {
        sku: 'SKU',
        productCostAmount: 'Cost HKD',
        dateEffectiveOn: 'Effective Date',
        dateCreateAt: 'Create date',
        dateModifyAt: 'Modify date',
        dateEffectiveOnFrom: 'Effective Date From',
        dateEffectiveOnTo: 'Effective Date To',
        action: 'Action'
    }
};
